/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { LogSource } from '../models/LogSource';
import { Pagination } from '../models/Pagination';

export class ListLogSourcesResponse {
  'logSources': Array<LogSource>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "logSources",
      "baseName": "logSources",
      "type": "Array<LogSource>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListLogSourcesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

